import { client } from './client'
import type {
  PagedResult,
  PaginationParams,
  SaveVariableGroupRequest,
  UpdateVariableGroupRequest,
  VariableGroup,
  VariableGroupSummary,
  VariableGroupUsage,
} from '@/types'

export const variableGroupsApi = {
  getAll: (projectId: string) =>
    client.get<VariableGroupSummary[]>(`/projects/${projectId}/variable-groups`).then(r => r.data),
  getById: (projectId: string, groupId: string) =>
    client.get<VariableGroup>(`/projects/${projectId}/variable-groups/${groupId}`).then(r => r.data),
  getUsage: (projectId: string, pagination: PaginationParams) =>
    client
      .get<PagedResult<VariableGroupUsage>>(`/projects/${projectId}/variable-groups/usage`, { params: pagination })
      .then(r => r.data),
  create: (projectId: string, group: SaveVariableGroupRequest) =>
    client.post<{ id: string }>(`/projects/${projectId}/variable-groups`, group).then(r => r.data),
  update: (projectId: string, groupId: string, group: UpdateVariableGroupRequest) =>
    client.put(`/projects/${projectId}/variable-groups/${groupId}`, group),
  delete: (projectId: string, groupId: string) =>
    client.delete(`/projects/${projectId}/variable-groups/${groupId}`),
}
